import { PaginationData } from '@modules/HappinessModule/interfaces/PaginationData';
import { createAction } from '@reduxjs/toolkit';

export const getSignInActivities = createAction<PaginationData>('userPage/getSignInActivities');
